module.exports = __webpack_public_path__ + "assets/img/62.8dbfeb98.png";